// RectangleNode.js

import React from "react";
import PropTypes from "prop-types";
import "./rectangle-node.css";
import { Handle, Position } from "reactflow";

const RectangleNode = ({ id, data, isConnectable, xPos, yPos }) => {
  return (
    <div
      className={`rectangle-node animated-box ${isConnectable ? "connectable" : ""}`}
      style={{ backgroundColor: data.backgroundColor }}
    >
      <Handle
        type="target"
        position={Position.Top}
        id={`${id}-target-top`}
        isConnectable={isConnectable}
        className="react-flow__handle-target"
      />
      <div>{data.label}</div>
      {/* <div className="position">X:{xPos} - Y:{yPos} </div> */}

      <Handle
        type="source"
        position={Position.Bottom}
        id={`${id}-bottom`}
        isConnectable={isConnectable}
        className="react-flow__handle-source"
      />
    </div>
  );
};

RectangleNode.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
  }),
  isConnectable: PropTypes.bool,
};

export default RectangleNode;
